import React from 'react'
import { connect } from 'react-redux'
import { Field, getFormValues } from 'redux-form'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { Cont, DPContainer } from './styled'
import { StdCard } from 'components'

const DownPaymentInformation = (props) => {
  const { dpDetail, valueForm } = props

  return (
    <React.Fragment>
      <DPContainer>
        <Cont>
          <StdCard title='Company' style={{ paddingRight: '0.9375rem', maxWidth: '100%' }} enableCollapse={false} hideHeader>
            <div className="rowFields">
              <Field
                name="companyCode"
                label="Company :"
                type={type.select}
                options={props.companies.data}
                loading={props.companies.loading}
                editable={false}
                component={FieldInput}
              />
              <Field
                name="companyTax"
                label="Tax Id :"
                type={type.text}
                editable={false}
                component={FieldInput}
              />
            </div>
            <Field
              name="companyAddress"
              label="Address :"
              type={type.text}
              editable={false}
              component={FieldInput}
            />
          </StdCard>
        </Cont>
      </DPContainer>
      <br />
      <Cont>
        <StdCard title='Payee Name ' style={{ paddingRight: '0.9375rem', maxWidth: '100%' }} enableCollapse={false} hideHeader >
          <DPContainer>
            <div className="rowFields">
              <Field
                name="payeeCode"
                label="Payee Name : "
                type={type.select}
                options={props.vendors.data}
                loading={props.vendors.loading}
                component={FieldInput}
                editable={false}
              />
              {
                dpDetail.isVendThai ?
                  <Field
                    name="payeeTax"
                    label="Tax Id :"
                    type={type.text}
                    editable={false}
                    component={FieldInput}
                  /> :
                  <Field
                    name="payeeTax"
                    label="Tax Id : "
                    type={type.text}
                    editable={false}
                    component={FieldInput}
                  />
              }
            </div>
            <Field
              name="payeeAddress"
              label="Address :"
              type={type.text}
              editable={false}
              component={FieldInput}
            />
          </DPContainer>
        </StdCard>
      </Cont>
      <br />
      <DPContainer>
        {valueForm.statusActivity === 'Procurement Upload Document' ?
          <div className="rowFields">
            <Field
              name="invoiceNumber"
              label="Invoice No."
              require={!dpDetail.isVendThai}
              type={type.text}
              component={FieldInput}
              editable={!dpDetail.isVendThai}
            />
            <Field
              name="invoiceDate"
              label="Invoice Date"
              require={!dpDetail.isVendThai}
              type={type.date}
              editable={!dpDetail.isVendThai}
              component={FieldInput}
            />
          </div>
          :
          <div className="rowFields">
            <Field
              name="invoiceNumber"
              label="Invoice No."
              type={type.text}
              component={FieldInput}
              editable={false}
            />
            <Field
              name="invoiceDate"
              label="Invoice Date"
              type={type.date}
              editable={false}
              component={FieldInput}
            />
          </div>
        }
      </DPContainer>
    </React.Fragment>

  )
}

const mapStateToProps = state => {
  const valueForm = getFormValues('formDP')(state) || {}

  var projectOptions = []
  if (valueForm.companyCode && state.goa.projects && state.goa.projects[valueForm.companyCode]) {
    projectOptions = state.goa.projects[valueForm.companyCode].map(p => {
      return { value: p.id, text: p.projectName }
    })

    if (state.goa.projects.other) {
      state.goa.projects.other.forEach(p => {
        projectOptions.push({ value: p.id, text: p.projectName })
      })
    }
  }
  return {
    dpDetail: state.downPayment.downPaymentDetail.data,
    members: state.member.members,
    companies: state.options.companies,
    vendors: state.options.vendors,
    valueForm,
  }
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(DownPaymentInformation)

